import { Link } from 'react-router-dom'
import { HelpCircle } from 'lucide-react'

// Small "?" next to a page title — opens the Help page at that page's section of public/help/04-pages.md
export default function HelpLink({ section }) {
  return (
    <Link to={`/help#pages-${section}`} className="help-link" title="How this page works" aria-label="Help for this page">
      <HelpCircle size={16} />
    </Link>
  )
}
